import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DtpDatepicker } from 'dtp-react-components';
import InputMask from './MaskedInput';
import masks from '../../utils/masks';

class DatePicker extends Component {
  // Metodo para prevenir updates desnecessarios como quando o DtpDatepicker
  // chama o handleFocus do DtpForm e desencadeia a renderizacao do componente
  // TODO Aprimorar sempre que percebermos um atributo que pode ser alterado via props.
  shouldComponentUpdate(nextProps) {
    return this.props.value !== nextProps.value;
  }

  handleChange = (e) => {
    this.props.onChange(e);
  }

  render() {
    if (this.props.disabled) {
      return (
        <InputMask
          disabled
          mask={masks.date}
          placeholder="dd/mm/aaaa"
          value={this.props.value}
        />
      );
    }
    return (
      <DtpDatepicker
        animated
        date={this.props.value}
        onChange={this.handleChange}
      />
    );
  }
}

DatePicker.propTypes = {
  value: PropTypes.instanceOf(Date),
  onChange: PropTypes.func,
}.isRequired;

export default DatePicker;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/DatePicker.jsx